import { captureException } from "@/src/lib/monitoring";

export const fetch = (url: any, method: any, param1: any, param2: any) => {
  return new Promise((resolve) => {
    method(url, param1, param2)
      .then((res: any) => resolve(res?.data))
      .catch((err: any) => {
        captureException(err, {
          tags: {
            source: "api-error",
            endpoint: url,
            statusCode: err?.response?.status ?? 0,
          },
          extra: {
            responseData: err?.response?.data,
          },
        });
        resolve(err?.response?.data);
      });
  });
};
